<div class="row">
  <div class="col text-center">
    <h3>Benvenuto {{nickname$ | async}}</h3>
  </div>
</div>
<app-dashboard-weco></app-dashboard-weco>
